/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAIImageGenerationBackendFromJSON, ApiAIImageGenerationBackendToJSON, } from './ApiAIImageGenerationBackend';
export function InlineObject2FromJSON(json) {
    return InlineObject2FromJSONTyped(json, false);
}
export function InlineObject2FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'aspectRatio': !exists(json, 'aspectRatio') ? undefined : json['aspectRatio'],
        'backend': !exists(json, 'backend') ? undefined : ApiAIImageGenerationBackendFromJSON(json['backend']),
        'prompt': !exists(json, 'prompt') ? undefined : json['prompt'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}
export function InlineObject2ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'aspectRatio': value.aspectRatio,
        'backend': ApiAIImageGenerationBackendToJSON(value.backend),
        'prompt': value.prompt,
        'size': value.size,
        'url': value.url,
    };
}
